// extracted by mini-css-extract-plugin
export var breadcrumb = "index-module--breadcrumb--0e53b";
export var title = "index-module--title--94416";